import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { Ring_circle } from "../../helper/imageConstant";

const ReturnPolicy = () => {
  return (
    <>
      <ImageSection name={"Return Policy"} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-8">
            <p className="text-base lg:text-base 3xl:text-lg font-medium">
              Vikas Fashion is committed to provide its customers complete
              satisfaction. In order to ensure the same, Vikas Fashion is always
              ready & willing to go the extra mile for its customers.
            </p>
            <p className="text-base lg:text-base 3xl:text-lg font-medium">
              We take stringent measures to ensure that the items delivered to
              you are in perfect condition. In case you are unsatisfied with the
              product received, you may contact us with your complaints /
              feedback at{" "}
              <span className="text-[#A5302E]">info@vikasfashion.com </span> &
              we shall revert back to you at the earliest.
            </p>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Item Received in Damaged Condition / Manufacturing Defect or
                Wrong Item
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  If you have received a damaged item or if the item you
                  received was not the item you ordered or if it was
                  misrepresented on our site, please contact us by email within
                  24 hours of your receipt of the product. It is important that
                  you save all packing materials as well as the item itself.
                  When you reach us, we'll give you instructions on how to
                  proceed.
                </li>
                <li>
                  We will express ship a replacement item at the earliest
                  possible with no extra shipping cost to you
                </li>
                <li>
                  If the original ordered item is no longer possible then we
                  will request you to choose an alternate item and express ship
                  the same to you with no extra shipping cost to you. We will
                  communicate with you about your wishes to make sure you will
                  be happy with the exchange.
                </li>
                <li>
                  If you do not want any alternate item then we will refund you
                  in full with no deduction whatsoever. Or any other amicable
                  resolution as mutually agreed with you.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Here Are Some Important & Helpful Guidelines on Returns{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Always email us first if you have a problem on
                  info@vikasfashion.com
                </li>
                <li>
                  Always be sure to report your problem within 24 hours of
                  receiving the item in question
                </li>
                <li>
                  Never send back an item without consulting with us. It's very
                  important that you DO NOT send the item back to us until you
                  have verified with us and no credit or replacement shall be
                  given on such items.
                </li>
                <li>
                  Always report any and all problems associated with a single
                  order/package delivery at the same time. Be as specific as
                  possible when describing the problem, as all returned items
                  are examined for defects / variations.
                </li>
                <li>
                  Always return your items using registered airmail / courier as
                  advised in our return authorization mail.
                </li>
                <li>
                  Any shipping costs of sending back to India above what
                  customer paid for shipping charges while receiving them from
                  India are the responsibility of the customer.
                </li>
                <li>
                  Please return within 7 working days of confirmation from our
                  end, and with original packing & in original condition
                  (please, no worn, washed, used or altered items). Please
                  ensure to include a copy of the invoice you received.
                </li>
                <li>
                  We will examine the garment you return, figure out what went
                  wrong, and take immediate steps to prevent such problems from
                  reoccurring.
                </li>
                <li>
                  As safe delivery to you is our responsibility, in the same way
                  sending back safely to us is your responsibility. If something
                  happens in transit and the package doesn't get delivered to
                  us, we cannot help you. So make sure to send thru suggested
                  postal service in our return authorization mail only and
                  forward the details to us and keep the airway bill or postal
                  receipt till it gets delivered to us.
                </li>
                <li>
                  Please mark the items as defective returns and not for sale
                  and declare a low nominal value.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Item availability failure{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  In case of multiple goods being ordered, if the delivery is
                  not possible for certain items, You will be requested to
                  select alternate items or if no alternate selection is desired
                  by then you will be promptly refunded against the
                  non-delivered goods or services along with their shipping
                  charges.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium ">
                Credit Issuals{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  All credits to be posted to a customer's credit card account
                  takes about 3 to 5 business days to be processed. The
                  corresponding bank of the customers may take about 2 business
                  days to actually post these to the customer's accounts from
                  the date we processed the credits. Customers can check these
                  credits in their next credit card statement.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Be Extra Alert when Accepting Parcel from Courier{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  If the outer packing is damaged or tampered with, do verify
                  the items quality and quantity with invoice before accepting
                  the package from the courier agency. In case of any
                  discrepancy, either refuse to accept delivery or accept
                  delivery only after putting suitable remark on the proof of
                  delivery. Also lodge proper complain with the local office of
                  the courier agency, so that we may pursue them.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Color & Description Disclaimer{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  The details of the products or product specifications (for
                  instance weight, color, handwork details, size, etc.) quoted
                  with the product displays are only approximate values.
                </li>
                <li>
                  While every endeavour has been made to accurately reproduce
                  colors, there may be minor variations in color of the actual
                  product because of the nature of fabric dyes, weather at the
                  time of dying and differences in display output due to
                  lighting and digital photography and color settings and
                  capabilities of monitors.
                </li>
                <li>
                  A customer must place an order keeping in mind this minor
                  variation in color as seen on a computer screen against the
                  actual color of the outfit received.
                </li>
                <li>
                  Vikas Fashion firmly believes that all the customers who order
                  online are aware that colors seen on a monitor will be
                  slightly different as compared to the actual outfits or
                  accessories ordered.
                </li>
                <li>
                  It is practically impossible for Vikas Fashion replicate the
                  same colors on an outfit as seen on your monitor. A variation
                  in the shade selected by you is considered as a normal
                  practice as these garments have a tendency to reflect
                  different shades of a color under different light and weather,
                  type of camera used for photography or type and settings on
                  the computer monitor.
                </li>
                <li>
                  We wish to clarify and ascertain that every customer who
                  orders any outfit from Vikas Fashion is aware of this genuine
                  problem.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                While ordering on internet, we suggest that customers should be
                extra careful of following{" "}
              </h1>
              <ul className="list-decimal pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Red, maroon and orange colors have a higher tendency to
                  reflect a different shade than other colors. For example even
                  if you yourself try to photograph from a digital camera or
                  scan a red garment, in most of the cases it will show either
                  as maroon or orange on the computer monitor and vice versa.
                  Though imaging technology has advanced, still no fool proof
                  solution to this problem is available at the moment.
                </li>
                <li>
                  Many a times green and blue shades also overlap. same is the
                  case with off-white, white and cream colors.
                </li>
                <li>
                  Sea Green color sometimes looks Aqua blue and the other way
                  around.
                </li>
                <li>
                  Some fabrics like raw silk, khadi silk, cotton silk, south
                  cotton, brocade have a textured effect where we can see the
                  weaving & threads are visible in different directions which is
                  a inherent characteristic or feature of that fabric and proof
                  of its authenticity. These are not defects. This raw finish is
                  the beauty of these fabrics.
                </li>
                <li>
                  Handcrafted, hand dyed, hand printed, hand painted, hand
                  embroidered, handloom, hand weaved products will always have
                  minor differences when we compare them as they are not made by
                  machines. Each piece will be unique. Handicraft artisans
                  always try their best to make each piece better than the
                  previous one. So, the product will always have minor variation
                  keeping the same theme constant in artistic manner. The raw
                  finish of the handicrafts cannot be compared with machine
                  finished products as this raw finish is the beauty of the
                  handicrafts items.
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Beads and Sequences Missing or Coming off{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We believe that customers who are ordering items with sequence
                  and other beaded embroidery are aware of the fact that these
                  shiny embellishments have a tendency to come off. Even with
                  the best of handling and care this cannot be avoided
                  altogether. Many a times during strict physical checking at
                  the customs during transit, more than usual sequences and
                  beads come off. Many a times it may happen that you open a box
                  and find some pieces falling down on the floor. Or you wear
                  the dress and in few hours you might loose some of them. Do
                  not panic or over-react because if you look with a magnifying
                  glass at any such dresses / sarees worn by others, you will
                  most certainly find some pieces missing or almost at a state
                  of falling down.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ReturnPolicy;
